{% block swag_migration_wizard_page_credentials_error %}
    <div class="swag-migration-wizard swag-migration-wizard-page-credentials-error">
        {% block swag_migration_wizard_page_credentials_error_content %}
        <div class="swag-migration-wizard__content">
            {% block swag_migration_wizard_page_credentials_error_information %}
            <div class="swag-migration-wizard__content-information">
                {% block swag_migration_wizard_page_credentials_success_bubble %}
                    <div class="swag-migration-wizard__bubble swag-migration-wizard__bubble--warning">
                        <mt-icon
                            class="swag-migration-wizard__warning-icon"
                            name="regular-exclamation-triangle"
                            size="36px"
                            decorative
                        />
                    </div>
                {% endblock %}

                {% block swag_migration_wizard_page_credentials_error_title %}
                    <h3 class="swag-migration-wizard__information-header">
                        {{ $tc('swag-migration.wizard.pages.credentials.error.contentTitle') }}
                    </h3>
                {% endblock %}

                {% block swag_migration_wizard_page_credentials_error_api_hint %}
                    <template v-if="errorMessageSnippet">
                        <p class="swag-migration-wizard__description">
                            {{ $tc(errorMessageSnippet) }}
                        </p>
                        <mt-banner
                            v-if="errorMessageHintSnippet"
                            class="swag-migration-wizard__description-hint"
                            :variant="errorMessageHintType"
                        >
                            {{ $tc(errorMessageHintSnippet) }}
                        </mt-banner>
                    </template>
                {% endblock %}
            </div>
            {% endblock %}
        </div>
        {% endblock %}
    </div>
{% endblock %}
